module.exports = __webpack_public_path__ + "sy.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sy.svg
// module id = 825
// module chunks = 0